import {AssetState} from "@generated"
import {StateLabel} from "@platform/models/state-labels/state-label"

export const AssetStateLabels: Map<AssetState, StateLabel<AssetState>> = new Map<AssetState, StateLabel<AssetState>>([
    [AssetState.InfoReview, {state: AssetState.InfoReview, label: "Info review", background: "#989898"}],
    [AssetState.Shading, {state: AssetState.Shading, label: "Shading", background: "#ffab4a"}],
    [AssetState.Review, {state: AssetState.Review, label: "Review", background: "#7cbcb0"}],
    [AssetState.Completed, {state: AssetState.Completed, label: "Completed", background: "#7ec17a"}],
])
